import React from 'react';
import BeyondBirdMemoryMinigame from './minigames/beyondBirdMemory/BeyondBirdMemoryMinigame';
import {
  BEYOND_BIRD_MEMORY_LOGICAL_WIDTH,
  BEYOND_BIRD_MEMORY_LOGICAL_HEIGHT,
} from './minigames/beyondBirdMemory/beyondBirdMemoryLayout';
import WombafleksCatchMinigame from './minigames/wombafleksCatch/WombafleksCatchMinigame';
import {
  WOMBAFLEKS_CATCH_LOGICAL_WIDTH,
  WOMBAFLEKS_CATCH_LOGICAL_HEIGHT,
} from './minigames/wombafleksCatch/wombafleksCatchLayout';
import RewardMemoryMinigame from './minigames/rewardMemory/RewardMemoryMinigame';
import {
  REWARD_MEMORY_LOGICAL_WIDTH,
  REWARD_MEMORY_LOGICAL_HEIGHT,
} from './minigames/rewardMemory/rewardMemoryLayout';
import BalloonBoothPopMinigame from './minigames/balloonBoothPop/BalloonBoothPopMinigame';
import {
  BALLOON_BOOTH_LOGICAL_WIDTH,
  BALLOON_BOOTH_LOGICAL_HEIGHT,
} from './minigames/balloonBoothPop/balloonBoothPopLayout';
import TheGambleMinigame from './minigames/theGamble/TheGambleMinigame';
import {
  THE_GAMBLE_LOGICAL_WIDTH,
  THE_GAMBLE_LOGICAL_HEIGHT,
} from './minigames/theGamble/theGambleLayout';
import SpottingObjectsMinigame from './minigames/spottingObjects/SpottingObjectsMinigame';
import {
  SPOTTING_OBJECTS_LOGICAL_WIDTH,
  SPOTTING_OBJECTS_LOGICAL_HEIGHT,
} from './minigames/spottingObjects/spottingObjectsLayout';

/** @type {Record<string, { Component: React.ComponentType, logicalWidth: number, logicalHeight: number, titleI18nKey: string }>} */
const EXPLORE_UNKNOWN_MINIGAME_REGISTRY = Object.freeze({
  beyondBirdMemory: {
    Component: BeyondBirdMemoryMinigame,
    logicalWidth: BEYOND_BIRD_MEMORY_LOGICAL_WIDTH,
    logicalHeight: BEYOND_BIRD_MEMORY_LOGICAL_HEIGHT,
    titleI18nKey: 'exploreUnknownPage.minigame.beyondBird.title',
  },
  wombafleksCatch: {
    Component: WombafleksCatchMinigame,
    logicalWidth: WOMBAFLEKS_CATCH_LOGICAL_WIDTH,
    logicalHeight: WOMBAFLEKS_CATCH_LOGICAL_HEIGHT,
    titleI18nKey: 'exploreUnknownPage.minigame.wombafleks.title',
  },
  rewardMemory: {
    Component: RewardMemoryMinigame,
    logicalWidth: REWARD_MEMORY_LOGICAL_WIDTH,
    logicalHeight: REWARD_MEMORY_LOGICAL_HEIGHT,
    titleI18nKey: 'exploreUnknownPage.minigame.rewardMemory.title',
  },
  balloonBoothPop: {
    Component: BalloonBoothPopMinigame,
    logicalWidth: BALLOON_BOOTH_LOGICAL_WIDTH,
    logicalHeight: BALLOON_BOOTH_LOGICAL_HEIGHT,
    titleI18nKey: 'exploreUnknownPage.minigame.balloonBooth.title',
  },
  theGamble: {
    Component: TheGambleMinigame,
    logicalWidth: THE_GAMBLE_LOGICAL_WIDTH,
    logicalHeight: THE_GAMBLE_LOGICAL_HEIGHT,
    titleI18nKey: 'exploreUnknownPage.minigame.theGamble.title',
  },
  spottingObjects: {
    Component: SpottingObjectsMinigame,
    logicalWidth: SPOTTING_OBJECTS_LOGICAL_WIDTH,
    logicalHeight: SPOTTING_OBJECTS_LOGICAL_HEIGHT,
    titleI18nKey: 'exploreUnknownPage.minigame.spottingObjects.title',
  },
});

/**
 * @param {string} minigameId
 */
export function getExploreUnknownMinigameEntry(minigameId) {
  if (typeof minigameId !== 'string' || !minigameId) {
    throw new Error(`getExploreUnknownMinigameEntry: invalid minigameId (${JSON.stringify(minigameId)})`);
  }
  const entry = EXPLORE_UNKNOWN_MINIGAME_REGISTRY[minigameId];
  if (!entry) {
    throw new Error(`getExploreUnknownMinigameEntry: unknown minigame ${JSON.stringify(minigameId)}`);
  }
  return entry;
}

export { EXPLORE_UNKNOWN_MINIGAME_REGISTRY };
